import(/* webpackMode: "eager" */ "/vercel/path0/src/app/auth/forgot-password/page.tsx");
